<template>
	<v-dialog
		v-model="localShowDialog"
		@click:outside="closeDialog"
		@keydown.esc="closeDialog"
		:width="$vuetify.display.mobile ? '95%' : '800px'"
		:max-width="$vuetify.display.mobile ? '95%' : '90vw'"
	>
		<v-card>
			<v-card-title class="dialog-header sgnl-subtitle-medium"
				>{{ title }}
				<v-spacer />
				<v-btn
					icon
					variant="text"
					size="small"
					@click="closeDialog"
				>
					<Close16 />
				</v-btn>
			</v-card-title>
			<v-divider />
			<v-card-text class="dialog-body file-viewer-body">
				<pre class="sgnl-code-default file-viewer-content">{{ fileText }}</pre>
			</v-card-text>
			<v-divider />
			<v-card-actions class="dialog-footer">
				<v-btn
					variant="flat"
					color="primary"
					@click="requestFileDownload()"
				>
					<Download16 />
					<span>Download</span>
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Close16 from "@carbon/icons-vue/es/close/16";
import Download16 from "@carbon/icons-vue/es/download/16";
export default defineComponent({
	name: "FileViewer",
	components: { Close16, Download16 },
	props: {
		showDialog: { type: Boolean, default: false },
		title: { type: String, default: "" },
		fileText: { type: String, default: "" },
	},
	emits: {
		"update:showDialog": (_data: boolean) => true,
		"download-file-request": (_data: string) => true,
	},
	computed: {
		localShowDialog: {
			get() {
				return this.showDialog;
			},
			set(value) {
				this.$emit("update:showDialog", value);
			},
		},
	},
	methods: {
		closeDialog() {
			this.$emit("update:showDialog", false);
		},
		requestFileDownload() {
			this.$emit("download-file-request", this.title);
		},
	},
});
</script>

<style lang="scss" scoped>
.file-viewer-body {
	min-height: 320px;
	max-height: 70vh;
	overflow: auto;
}

.file-viewer-content {
	white-space: pre-wrap;
	overflow-wrap: anywhere;
	margin: 0;
}
</style>
